let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("6QpGT")]).then(() => parcelRequire('9toZG'));